import type { ReactNode } from 'react';
import { Boton } from '../../components/ui.js';
import type { SetRecommendation } from '../../data/services/recommendationService.js';
import { explainRecommendation } from './porQue.js';

/**
 * Panel «¿Por qué?» (docs/UI_UX_SPEC.md §4.11).
 * Silencioso por defecto: solo aparece si el usuario lo pide.
 *
 * Quien abre y cierra es la pantalla, no el panel. Tenia su propio `useState` y
 * pintaba tambien su disparador, asi que el disparador solo podia estar donde
 * estuviera el panel; el §4.7 dibuja «¿Por qué? · Sustituir ejercicio» en una
 * MISMA fila de acciones secundarias, y para eso los dos disparadores tienen que
 * ser hermanos y el contenido abrirse debajo de la fila.
 */
export function PorQuePanel({
  recomendacion,
  ejercicio,
  serie,
  totalSeries,
  onCerrar,
}: {
  recomendacion: SetRecommendation;
  ejercicio: string;
  serie: number;
  totalSeries: number;
  onCerrar: () => void;
}): ReactNode {
  const explicacion = explainRecommendation(recomendacion, { ejercicio, serie, totalSeries });

  return (
    <section className="por-que" aria-label="Explicación de la recomendación">
      <div className="por-que__bloque">
        <h3 className="por-que__titulo">Datos</h3>
        <ul className="por-que__lista">
          {explicacion.datos.map((dato) => (
            <li key={dato}>{dato}</li>
          ))}
        </ul>
      </div>
      <div className="por-que__bloque">
        <h3 className="por-que__titulo">Qué propongo</h3>
        <p>{explicacion.queCambio}</p>
      </div>
      <div className="por-que__bloque">
        <h3 className="por-que__titulo">Por qué</h3>
        <p>{explicacion.objetivo}</p>
      </div>
      <div className="por-que__bloque">
        <h3 className="por-que__titulo">Qué espero</h3>
        <p>{explicacion.resultadoEsperado}</p>
      </div>
      <div className="por-que__bloque">
        <h3 className="por-que__titulo">Cuándo se revisa</h3>
        <p>{explicacion.reevaluacion}</p>
      </div>
      <Boton variante="texto" aria-expanded onClick={onCerrar}>
        Cerrar
      </Boton>
    </section>
  );
}
